import { roles } from "../../../config/config";

export const learningAdminRoles = [roles.admin, roles.gestore, roles.developer, roles.grafico];

export const learningResultsRoles = [
  ...learningAdminRoles,
  roles.agenteRoypet,
  roles.agenteRoydermal,
  roles.agenteValderma,
  roles.agenteCompleto,
  roles.dipendente,
].filter((role) => role !== undefined);

export const learningViewerRoles = learningResultsRoles;

export const getLearningMenuPermissions = (userIsAgente) => [
  ...learningAdminRoles,
  userIsAgente,
];

export const getLearningResultsPermissions = (userIsAgente) => [
  ...learningAdminRoles,
  userIsAgente,
];

export const isLearningAdmin = (role) => learningAdminRoles.includes(parseInt(role, 10));
